"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SecondaryButtonLink = exports.SecondaryButton = void 0;
const react_1 = __importDefault(require("react"));
const styled_1 = __importDefault(require("@emotion/styled"));
const ui_theme_1 = require("@kyruus/ui-theme");
exports.SecondaryButton = (0, styled_1.default)('button') `
  cursor: pointer;
  background-color: ${(0, ui_theme_1.fromTheme)('color_button_secondary')};
  color: ${(0, ui_theme_1.fromTheme)('color_text')};
  border: ${(0, ui_theme_1.fromTheme)('border_width')} ${(0, ui_theme_1.fromTheme)('border_style')}
    ${(0, ui_theme_1.fromTheme)('color_border')};
  border-radius: ${(0, ui_theme_1.fromTheme)('border_radius')};
  font-family: ${(0, ui_theme_1.fromTheme)('font_face')};
  font-size: ${(0, ui_theme_1.fromTheme)('font_size')};
  font-weight: ${(0, ui_theme_1.fromTheme)('font_weight')};
  padding: ${(0, ui_theme_1.fromTheme)('spacing_small')} ${(0, ui_theme_1.fromTheme)('spacing_medium')};
  text-decoration: none;
  display: inline-block;
  &:focus {
    background-color: ${(0, ui_theme_1.fromTheme)('color_background')};
    border-color: ${(0, ui_theme_1.fromTheme)('color_border_emphasis')};
    outline-color: ${(0, ui_theme_1.fromTheme)('color_border_emphasis')};
    outline-width: ${(0, ui_theme_1.fromTheme)('border_width')};
    outline-style: ${(0, ui_theme_1.fromTheme)('border_style')};
    outline-offset: 0;
  }
  &:hover {
    background-color: ${(0, ui_theme_1.fromTheme)('color_button_active')};
    color: ${(0, ui_theme_1.fromTheme)('color_text_contrast')};
  }
  &:active:not(:disabled) {
    outline-color: ${(0, ui_theme_1.fromTheme)('color_button_active')};
    outline-width: ${(0, ui_theme_1.fromTheme)('border_width')};
    outline-style: ${(0, ui_theme_1.fromTheme)('border_style')};
    outline-offset: ${(0, ui_theme_1.fromTheme)('border_width')};
    background-color: ${(0, ui_theme_1.fromTheme)('color_button_active')};
    border-color: ${(0, ui_theme_1.fromTheme)('color_button_active')};
    color: ${(0, ui_theme_1.fromTheme)('color_text_contrast')};
  }
  &:disabled {
    cursor: not-allowed;
    background-color: ${(0, ui_theme_1.fromTheme)('color_button_secondary_disabled')};
    color: ${(0, ui_theme_1.fromTheme)('color_text_button_disabled')};
    border-color: ${(0, ui_theme_1.fromTheme)('color_border_disabled')};
  }
`;
exports.SecondaryButtonLink = (0, styled_1.default)((props) => (react_1.default.createElement(exports.SecondaryButton, Object.assign({ as: "a" }, props)))) ``;
//# sourceMappingURL=secondary.js.map